<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="nudge"
    transition="scale-transition"
    :offset-y="offsetY"
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="formattedDate"
        :label="label"
        :rules="rules"
        append-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
        :id="id"
      ></v-text-field>
    </template>
    <v-date-picker
      :value="value"
      type="month"
      @input="
        menu = false;
        $emit('input', $event);
      "
      locale="nl-BE"
      :allowed-dates="allowed"
    ></v-date-picker>
  </v-menu>
</template>

<script lang="ts">
import { Component, Prop, Provide } from 'vue-property-decorator';
import { LocaleMessage } from 'vue-i18n';
import { mixins } from 'vue-class-component';
import TextInputMixin from '@/mixins/inputMixins/subMixins/TextInputMixin';

@Component
export default class DateMonthPicker extends mixins(TextInputMixin) {
  @Prop(Function) readonly allowed: boolean | undefined;
  @Prop(String) readonly id: string | undefined;
  @Prop(String) readonly value: string | undefined;
  @Prop(String) readonly label: string | LocaleMessage | undefined;
  @Prop({ default: 40 }) readonly nudge: string | LocaleMessage | undefined;
  @Prop({ default: true }) readonly offsetY: string | LocaleMessage | undefined;
  @Prop({ default: Array }) readonly rules!: ((v: string) => string | boolean | LocaleMessage)[];

  @Provide() menu = false;

  get formattedDate() {
    if (!this.value) return null;

    const [year, month] = this.value.split('-');
    return `${month}/${year}`;
  }
}
</script>
